module.exports = __webpack_public_path__ + "img/income-history.b94ab467.svg";